import type { MinimalFormField, Resolver } from "../types/form-fields";

export const defineFormBuilderResolver = <T extends MinimalFormField<any>>({
  type,
  defaultValue,
  component,
  hasSubFields = false,
  isLoopable = false,
}: Resolver<T> & { type: T["type"] }): Resolver<T> => ({
  type,
  component,
  defaultValue,
  hasSubFields,
  isLoopable,
});
